export default {
  productTitle: 'product_title_plp',
  productBrand: 'product_brand_plp',
  productPrice: 'product_price_plp',
  productImage: 'product_image_plp',
  addToBagBtn: 'product_add_to_bag_plp',
  addToFavoritetn: 'product_add_to_favorite_plp',
};
